import { media, styled } from '@nx-kit/styling';
import Column from 'components/layout/Grid/Column';
import EventSliderItem from 'components/molecules/EventSliderItem/EventSliderItem';
import { DatePicker } from 'components/molecules/DatePicker';

export const BgMotivStyled = styled.div`
  position: absolute;
  height: 500px;
  width: 100%;
  z-index: -1;
  img {
    position: absolute;
    right: 0;
    top: 0;
    margin-right: -80px;
    width: 1900px;
    height: 950px;
    opacity: 0.25;
  }
`;

export const RowSortStyled = styled.div`
  display: flex;
  align-items: flex-start;
  margin-bottom: 50px;
  flex-direction: column;

  ${media('md')} {
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const RowFilterHeadlineStyled = styled.div`
  font-weight: 700;
`;

export const DatePickersGroupStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 16px;
`;

export const ColumnStyled = styled(Column)`
  position: relative;
`;

export const RowFilterStyled = styled.div`
  display: flex;
  align-items: center;
  margin: 30px 0 40px;
  ${media('md')} {
    margin: 30px 0 60px;
  }
`;

export const FilterGroupStyled = styled.div`
  display: flex;
  flex-direction: column;
`;

export const RowGridStyled = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const RowLoadingStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 80px;
`;

export const RowPaginationStyled = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
`;

export const EventSliderItemStyled = styled(EventSliderItem)`
  flex: 1 1 auto;

  ${media('sm')} {
    flex: 1 1 50%;
    max-width: calc(50% - 16px);
  }

  ${media('md')} {
    flex: 1 1 30%;
    max-width: calc(33% - 32px);
  }
`;

export const DatePickerStyled = styled(DatePicker)`
  margin: 0;
`;
